module.exports = {"pt-BR":{"components":{"property-card":{"bedrooms":{"one":"1 quarto","other":"%{count} quartos"}}}}}